import { render, staticRenderFns } from "./SearchAppVersion.vue?vue&type=template&id=3bef1194&scoped=true"
import script from "./SearchAppVersion.vue?vue&type=script&lang=js"
export * from "./SearchAppVersion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bef1194",
  null
  
)

export default component.exports